import { IState } from '../../../store';

export const selectNewbuildingTour = (state: IState): string | null => {
  return state.offerData.tours?.newbuildingTour?.tourKey || null;
};
